<template>
    <report-example
        :loader="!isFetched"
        :product="product"
    />
</template>

<script>
    import { fetchProductDescription } from '../../../services/api/request';
    import ReportExample from './ReportExample.vue';

    export default {
        name: 'report-example-container',
        components: {
            ReportExample,
        },
        data() {
            return {
                isFetched: false,
                product: {},
            }
        },
        created() {
            fetchProductDescription(this.$route.params.id)
                .then((res) => {
                    this.product = res.data;
                    this.isFetched = true;
                });
        }
    }
</script>


// WEBPACK FOOTER //
// ReportExampleContainer.vue?0d33ff35